import { render, staticRenderFns } from "./onlineAnswer.vue?vue&type=template&id=2ccb0ee5&scoped=true&"
import script from "./onlineAnswer.vue?vue&type=script&setup=true&lang=js&"
export * from "./onlineAnswer.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./onlineAnswer.vue?vue&type=style&index=0&id=2ccb0ee5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ccb0ee5",
  null
  
)

export default component.exports